import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import ThreeOptions from '../ThreeOptions'
import StepCounter from '../StepCounter'

import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import gif4 from './assets/07_bag 2.gif'
import jpg4 from './assets/static/07_bag-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q4() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif4" src={settings.isAnimationPause ? jpg4 : gif4} />
            </div>
            <Headling text={translate('Your Order’s Been Shipped')} />
            <Subtitle text={translate('How much money have I spent online, shopping on international sites?')} />
            <ThreeOptions option1={translate('Less than NIS 500 a year')}
                option2={translate('NIS 500-1,000 a year')}
                option3={translate('More than NIS 1,000 a year')} 
                onOption1Press={() => {
                    setNewAnswer({ 4:1 })
                    history.push('/Q/5')
                    ReactPixel.trackCustom('less_500', '');
                }}
                onOption2Press={() => {
                    setNewAnswer({ 4: 2 })
                    history.push('/Q/5')
                    ReactPixel.trackCustom('500_to_1000', '');
                }}
                onOption3Press={() => {
                    setNewAnswer({ 4: 3 })
                    history.push('/Q/5')
                    ReactPixel.trackCustom('more_1000', '');
                }}
                />
            <StepCounter />

        </>
    )
}



export default Q4

